import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/components/Landing/Content/GoMainBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/components/Landing/Content/PopularCardContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/components/Landing/LandingSearchButton.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/app/css/landing.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/legacy/image.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
